export default __webpack_public_path__ + "static/lehr-equation-dark-98e167f17d20bddab9fb08da77c0ba44.png";